<template>
  <div class="question" id="question" v-if="titleConfig">
    <div class="card" v-viewer="{ toolbar: false, navbar: false }">
      <div class="titleWrap">
        <p class="questionTitle">
          {{ currentIndex + 1 }}.
          {{ $filters.breakLine(translate[titleConfig.id]) }}
          <!-- 题目类型展示, 多选展示限制数量 -->
          <span class="titleSuffix" v-if="questionTitleType !== 'hide'">{{
            `(${$t(questionTitleType)}${
              isMultipleChooseAndLimit.maxChooseCount
                ? ", " +
                  $t("leastChoose").replace(
                    "xxx",
                    isMultipleChooseAndLimit.maxChooseCount
                  )
                : ""
            })`
          }}</span>
          <!-- 填空题限制展示 -->
          <span class="titleSuffix">{{
            showLimitCount
              ? $t("textLimit")
                  .replace("xx", currentAnswerConfig.minCount)
                  .replace("yyy", currentAnswerConfig.maxCount)
              : ""
          }}</span>
          <span
            class="youtube-btn"
            v-if="titleConfig.videoUrl?.length"
            @click="showYoutubePopup(titleConfig.videoUrl)"
          ></span>
        </p>
        <img
          v-if="titleConfig.picUrl"
          :src="titleConfig.picUrl"
          alt="titlePic"
          class="titlePic"
        />
      </div>
      <component :is="currentComponent" class="questionType"></component>
    </div>
    <div class="btnWrap">
      <Tips v-if="checkTips.length" :tips="checkTips"></Tips>
      <a
        href="javascript:void(0)"
        class="switchButton"
        v-if="currentValidQuestionIndex !== -1"
        @click="nextQuestion"
        >{{ $t("next") }}</a
      >
      <a
        href="javascript:void(0)"
        class="switchButton"
        v-if="currentValidQuestionIndex === -1"
        @click="commitSurvey"
        >{{ $t("submit") }}</a
      >
      <a
        href="javascript:void(0)"
        class="prevQuestion"
        v-if="prevQuestionIndex !== -1"
        @click="prevQuestion"
        >&lt&lt {{ $t("prev") }}</a
      >
    </div>
  </div>
</template>
<script setup>
import Tips from "@/components/common/Tips.vue";
import questionHook from "../hooks/questionHook";
import { computed } from "vue";
import { useStore } from "vuex";
import { showYoutubePopup } from "../hooks/popupHook";
const store = useStore();
const titleConfig = computed(() => store.getters["survey/currentTitleConfig"]);
const translate = computed(() => store.state.survey.translate);
const {
  currentComponent,
  nextQuestion,
  prevQuestion,
  commitSurvey,
  currentValidQuestionIndex,
  prevQuestionIndex,
  checkTips,
  currentIndex,
  questionTitleType,
  showLimitCount,
  isMultipleChooseAndLimit,
  currentAnswerConfig,
} = questionHook();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.question {
  @include setBackground(100%, auto, "default_bg.jpg");
  min-height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  padding: 150px 30px 100px;
  @media screen and (orientation: landscape) {
    padding: 150px 30px 60px;
  }
  .card {
    overflow: hidden;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
    width: 100%;
    margin: 0 auto;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 30px 40px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    @media screen and (orientation: landscape) {
      padding: 30px 40px;
      border-radius: 10px;
      max-width: 80%;
    }
    @media screen and (min-width: 960px) {
      max-width: 60%;
    }
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .titleWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    @media screen and (orientation: landscape) {
      margin-bottom: 20px;
    }
  }
  .titlePic {
    margin-bottom: 30px;
    max-width: 90%;
    cursor: pointer;
    position: relative;
    border-radius: 15px;
    @media screen and (orientation: landscape) {
      max-width: 760px;
      margin-bottom: 30px;
      border-radius: 15px;
    }
  }

  .questionTitle {
    width: 100%;
    font-size: 30px;
    line-height: 40px;
    margin: 0 auto 30px;
    word-break: break-word;
    @media screen and (orientation: landscape) {
      font-size: 30px;
      line-height: 40px;
      margin: 0 auto 30px;
    }
    .titleSuffix {
      color: #999;
    }
  }
  .youtube-btn {
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 35px;
    margin-left: 20px;
    background: url($imgURL + "youtube_btn.png") no-repeat center;
    background-size: contain;
    transition: filter 0.4s;
    @media screen and (orientation: landscape) {
      width: 50px;
      height: 35px;
      margin-left: 20px;
    }
    &:hover {
      filter: brightness(1.1);
    }
  }
  .btnWrap {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    @media screen and (orientation: landscape) {
      margin-top: 30px;
    }
  }
  .switchButton {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $btnColor;
    width: 600px;
    height: 80px;
    transition: filter 0.4s;
    color: #fff;
    border-radius: 10px;
    font-size: 20px;
    margin: 20px 0 5px;
    flex-shrink: 0;
    @media screen and (orientation: landscape) {
      width: 600px;
      height: 80px;
      border-radius: 10px;
      font-size: 20px;
      margin: 20px 0 5px;
    }
    @media screen and (orientation: portrait) {
      width: 100%;
    }
    &:hover {
      filter: brightness(1.1);
    }
  }
  .prevQuestion {
    font-size: 20px;
    color: #333;
    padding: 20px;
    @media screen and (orientation: landscape) {
      margin-top: 10px;
      padding: 20px;
      font-size: 20px;
    }
  }
}
</style>
